import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Building2, Shield, FileText } from "lucide-react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";

export default function PoliticaPrivacidade() {
  const [politica, setPolitica] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPolitica();
  }, []);

  const fetchPolitica = async () => {
    try {
      const response = await axios.get(`${API_URL}/lgpd/politica`);
      setPolitica(response.data);
    } catch (error) {
      console.error("Error fetching policy:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8FAFC]">
      {/* Header */}
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2 text-slate-600 hover:text-white transition-colors">
              <ArrowLeft className="w-5 h-5" />
              <span>Voltar</span>
            </Link>
            <div className="flex items-center gap-2">
              <div className="w-8 h-8 bg-[#05050A] rounded-lg flex items-center justify-center">
                <Building2 className="w-5 h-5 text-white" />
              </div>
              <span className="font-semibold text-white">CONTERP</span>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-[#0EA5E9]/10 text-white px-4 py-2 rounded-full text-sm font-medium mb-4">
            <Shield className="w-4 h-4 text-[#0EA5E9]" />
            Conformidade LGPD
          </div>
          <h1 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Política de Privacidade
          </h1>
          <p className="text-slate-600">
            Última atualização: {politica?.ultima_atualizacao || "---"}
          </p>
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-64">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1a1a2e]"></div>
          </div>
        ) : (
          <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-8 md:p-12">
            <div className="prose prose-slate max-w-none">
              <pre className="whitespace-pre-wrap font-sans text-slate-600 text-sm leading-relaxed">
                {politica?.conteudo}
              </pre>
            </div>
          </div>
        )}

        {/* LGPD Request Section */}
        <div className="mt-12 bg-[#05050A]/5 rounded-xl p-8">
          <div className="flex items-start gap-4">
            <FileText className="w-6 h-6 text-white flex-shrink-0" />
            <div>
              <h2 className="text-xl font-semibold text-white mb-2">
                Seus Direitos (LGPD)
              </h2>
              <p className="text-slate-600 mb-4">
                Você pode exercer seus direitos de titular de dados a qualquer momento:
              </p>
              <ul className="text-slate-600 space-y-2 mb-6">
                <li>• <strong>Acesso:</strong> Solicitar informações sobre seus dados</li>
                <li>• <strong>Correção:</strong> Corrigir dados incompletos ou incorretos</li>
                <li>• <strong>Eliminação:</strong> Solicitar a exclusão de seus dados</li>
                <li>• <strong>Portabilidade:</strong> Receber seus dados em formato estruturado</li>
              </ul>
              <p className="text-slate-600">
                Para exercer seus direitos, entre em contato:{" "}
                <a href="mailto:support@ombudnow.com" className="text-[#0EA5E9] hover:underline">
                  support@ombudnow.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
